import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 252体力锁
 */

export default class EventVitLock extends EventBase {
  constructor() {
    super()
    this.Parameter = ['0', '100']
  }

  get UniqueId() {
    return this.Parameter?.[0] ?? ''
  }
  set UniqueId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  get VitValue() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set VitValue(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  Code = EventID.VitLock
  public GetParameter() {
    return this.Parameter
  }
}
